import { ResultItem } from './resultItem.interface';
import { ObservationDetails } from '../observationDetails';
import { ObservationsService } from 'src/app/services/observations.service';
import { ResultItemType } from './resultItemType.enum';
import { SafeHtml } from '@angular/platform-browser';
import { SelectableObservationSummary } from '../selectableObservationSummary';

export class SearchResultItem implements ResultItem {
  public readonly type = ResultItemType.SEARCH;

  private obsService: ObservationsService;

  private obsDetails: ObservationDetails;

  private markerIconHtml: SafeHtml;
  private error = false;

  public constructor(
    private obsSummary: SelectableObservationSummary,
  ) {
  }

  get summaryObject(): SelectableObservationSummary {
    return this.obsSummary;
  }
  get detailObject(): ObservationDetails {
    return this.obsDetails;
  }

  get isReady(): boolean {
    return (null != this.obsDetails);
  }
  get isError(): boolean {
    return this.error;
  }

  get name(): string {
    return this.obsSummary.description;
  }
  get sourceName(): string {
    return this.obsSummary.source.name;
  }
  get iconHtml(): SafeHtml {
    return this.markerIconHtml;
  }

  public setObservationService(obsService: ObservationsService): this {
    this.obsService = obsService;
    return this;
  }

  public populate(): void {
    this.obsService.getDetails(this.obsSummary.id)
      .then((obsDetails: ObservationDetails) => {
        this.obsDetails = obsDetails;
        this.error = false;
        return obsDetails;
      })
      .catch((err) => {
        this.error = true;
        throw err;
      });

  }

  public setIcon(iconHtml: SafeHtml): this {
    this.markerIconHtml = iconHtml;
    return this;
  }

}
